/** Catálogo demo de reportes ejecutivos — sin export real (v0.3.5.1). */

export const DEMO_REPORTS = [
  {
    id: 'r-monthly',
    titleKey: 'reportsPage.items.monthly.title',
    descKey: 'reportsPage.items.monthly.desc',
    freqKey: 'reportsPage.freqMonthly',
    audienceKey: 'reportsPage.audienceDirection',
    statusKey: 'reportsPage.statusPrepared',
  },
  {
    id: 'r-docs',
    titleKey: 'reportsPage.items.docs.title',
    descKey: 'reportsPage.items.docs.desc',
    freqKey: 'reportsPage.freqMonthly',
    audienceKey: 'reportsPage.audienceCompliance',
    statusKey: 'reportsPage.statusReady',
  },
  {
    id: 'r-att',
    titleKey: 'reportsPage.items.attendance.title',
    descKey: 'reportsPage.items.attendance.desc',
    freqKey: 'reportsPage.freqWeekly',
    audienceKey: 'reportsPage.audienceOps',
    statusKey: 'reportsPage.statusReady',
  },
  {
    id: 'r-leave',
    titleKey: 'reportsPage.items.leaves.title',
    descKey: 'reportsPage.items.leaves.desc',
    freqKey: 'reportsPage.freqWeekly',
    audienceKey: 'reportsPage.audienceManagers',
    statusKey: 'reportsPage.statusReady',
  },
  {
    id: 'r-exp',
    titleKey: 'reportsPage.items.expenses.title',
    descKey: 'reportsPage.items.expenses.desc',
    freqKey: 'reportsPage.freqBiweekly',
    audienceKey: 'reportsPage.audienceFinance',
    statusKey: 'reportsPage.statusReady',
  },
  {
    id: 'r-perf',
    titleKey: 'reportsPage.items.performance.title',
    descKey: 'reportsPage.items.performance.desc',
    freqKey: 'reportsPage.freqSemiannual',
    audienceKey: 'reportsPage.audienceManagers',
    statusKey: 'reportsPage.statusPrepared',
  },
  {
    id: 'r-train',
    titleKey: 'reportsPage.items.training.title',
    descKey: 'reportsPage.items.training.desc',
    freqKey: 'reportsPage.freqMonthly',
    audienceKey: 'reportsPage.audiencePeople',
    statusKey: 'reportsPage.statusPrepared',
  },
  {
    id: 'r-climate',
    titleKey: 'reportsPage.items.climate.title',
    descKey: 'reportsPage.items.climate.desc',
    freqKey: 'reportsPage.freqQuarterly',
    audienceKey: 'reportsPage.audienceLeadership',
    statusKey: 'reportsPage.statusPrepared',
  },
  {
    id: 'r-culture',
    titleKey: 'reportsPage.items.culture.title',
    descKey: 'reportsPage.items.culture.desc',
    freqKey: 'reportsPage.freqQuarterly',
    audienceKey: 'reportsPage.audienceLeadership',
    statusKey: 'reportsPage.statusPrepared',
  },
  {
    id: 'r-exec',
    titleKey: 'reportsPage.items.executive.title',
    descKey: 'reportsPage.items.executive.desc',
    freqKey: 'reportsPage.freqMonthly',
    audienceKey: 'reportsPage.audienceDirection',
    statusKey: 'reportsPage.statusPrepared',
  },
  {
    id: 'r-audit',
    titleKey: 'reportsPage.items.audit.title',
    descKey: 'reportsPage.items.audit.desc',
    freqKey: 'reportsPage.freqMonthly',
    audienceKey: 'reportsPage.audienceCompliance',
    statusKey: 'reportsPage.statusPrepared',
  },
];
